import { Directive } from '@angular/core';
@Directive({ selector: 'time'})
export class TimeDirective {}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/utils/time.directive.ts